import Referral from "@/views/referral";
import Head from "next/head";
import React from "react";

const ReferralPage = () => {
  return (
    <>
      <Head>
        <title>Referral | Zelevate</title>
      </Head>
      <Referral />
    </>
  );
};

export default ReferralPage;

export async function getStaticProps() {
  return {
    props: {},
  };
}
